<template>
	<div class="body">
		<div class="body-container" v-if="list && list.length > 0">
			<div class="item-ctr" v-for="(item, index) in list" :key="index">
				<div class="item-title">{{item.title}}</div>

				<el-table border :data="item.list" stripe=''>
					<el-table-column label="年份" align="center" prop="year" min-width="1">
						<template v-slot="{ row }">
							<label>{{row.year}}</label>
						</template>
					</el-table-column>

					<el-table-column label="全国企业数" align="center" prop="company_num" min-width="2">
						<template v-slot="{ row }">
							<label>{{row.nation.company_num}}</label>
						</template>
					</el-table-column>
					<el-table-column :label="item.province + '企业数'" align="center" prop="company_num" min-width="2">
						<template v-slot="{ row }">
							<label>{{row.local.company_num}}</label>
						</template>
					</el-table-column>

					<el-table-column label="全国营业收入" align="center" prop="company_income" min-width="2">
						<template v-slot="{ row }">
							<label>{{row.nation.company_income}}</label>
						</template>
					</el-table-column>
					<el-table-column :label="item.province + '营业收入'" align="center" prop="company_income" min-width="2">
						<template v-slot="{ row }">
							<label>{{row.local.company_income}}</label>
						</template>
					</el-table-column>

					<el-table-column label="全国平均用工人数" align="center" prop="employee_num" min-width="2">
						<template v-slot="{ row }">
							<label>{{row.nation.employee_num}}</label>
						</template>
					</el-table-column>
					<el-table-column :label="item.province + '平均用工人数'" align="center" prop="employee_num" min-width="2">
						<template v-slot="{ row }">
							<label>{{row.local.employee_num}}</label>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div v-else class="empty-ctr">
			<div class="empty-tips">该行业暂无数据</div>
		</div>
		
		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickCareer()" class="next-btn">下一步</el-button>
		</div>
	</div>
</template>

<script>
	import {
		getIndustryData
	} from "@/api/matrix"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				majorData: null,
				industryData: null,
				majorSpanMap: {},
				industrySpanMap: {},
				showGroupIndustryDialog: false,
				navList: [{
						'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13152635-89000603806795123.png',
						'name': '专业群分析',
						'url': 'replace://matrix?activeLeftTab=5'
					},
					{
						'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13153102-77494491196988002.png',
						'name': '共性行业',
						'url': ''
					}
				],
				groupAddList: [{
						'name': '未添加',
						'value': 2
					},
					{
						'name': '已添加',
						'value': 1
					},
				],
				groupAddState: 2,
				groupAddIndex: 0,
				topIndustry: '',
				topIndustryList: [],
				groupQueryParams: {
					page: 1,
					pageSize: 10
				},
				groupDataList: [],
				total: 0,
				majorCodes: '',
				sameMap: {},
				list: []
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.requestData();
			},

			requestData() {
				this.groupId = this.$route.query.id;
				this.codes = this.$route.query.codes;
				getIndustryData({
					'group_id': this.groupId,
					'codes': this.codes
				}).then(res => {
					console.log('groupId', this.groupId)
					let realData = res.data;
					this.list = realData.list;
				});
			},
			
			clickCareer() {
				let path = '/industry_career?id=' + this.groupId + '&codes=' + this.codes;
				console.log('path', path)
				this.$router.push(path);
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "industry_data.scss";
</style>